exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".modal[data-v-22776aaa]{height:100%;left:0;position:fixed;top:0;width:100%;z-index:200}.modal__header[data-v-22776aaa]{height:48px}.modal__footer[data-v-22776aaa]{width:100%;height:64px;padding:0 10px}.modal__content[data-v-22776aaa]{width:100%;overflow-y:auto;padding:10px 24px}.btn[data-v-22776aaa]{margin:10px 0}.name[data-v-22776aaa]{padding-right:16px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-22776aaa","scoped":true,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/PromotionDialog.vue
// module id = YZOW
// module chunks = 0